import React from "react";
import { FaCalendarAlt, FaCog } from "react-icons/fa";
import AppButton from "../../layout/AppButton";

const AnalyticsHeader = ({
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
  onCustomize,
}) => {
  return (
    <div className="flex items-center justify-between flex-wrap gap-4">
      <div>
        <h2 className="text-xl font-bold text-gray-800">Analytics Dashboard</h2>
        <p className="text-xs text-gray-400 mt-1">Track usage, engagement, and activity across all groups</p>
      </div>
      <div className="flex items-center gap-3">
        {/* Date Range */}
        <div className="flex items-center gap-2 rounded-xl border border-gray-200 bg-white px-3 py-1.5 shadow-sm">
          <FaCalendarAlt size={11} className="text-gray-400" />
          <input
            type="date"
            value={dateFrom}
            onChange={(e) => onDateFromChange(e.target.value)}
            className="w-[120px] bg-transparent text-xs text-gray-700 focus:outline-none"
          />
          <span className="text-gray-300">—</span>
          <input
            type="date"
            value={dateTo}
            onChange={(e) => onDateToChange(e.target.value)}
            className="w-[120px] bg-transparent text-xs text-gray-700 focus:outline-none"
          />
        </div>
        <AppButton
          onClick={onCustomize}
          variant="secondary"
          icon={<FaCog size={11} />}
        >
          Customize
        </AppButton>
      </div>
    </div>
  );
};

export default AnalyticsHeader;
